/* eslint-disable react/prop-types, react/destructuring-assignment */
import React, { useCallback, useEffect } from 'react'
import { Button, Dropdown, Image } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { GWS, OFFICE365 } from '../../../../app/pages/home/engage/utils'
import {
  DIRECTORY_INTEGRATION_PREFERENCE,
  getPreferredDirectoryIntegration,
  selectDirectoryIntegration,
} from '../../../../app/pages/home/utils/integrations'
import * as integrations from '../../../ducks/integrations'
import { getSelectedCustomerId } from '../../../selectors/customers'

const ALLOWED_DIRECTORY_INTEGRATIONS = [OFFICE365, GWS]
const SECURE_DIRECTORY_PREFERENCE = [OFFICE365]

function IntegrationsButton({
  isChildLoading,
  integrationsAllowed = ALLOWED_DIRECTORY_INTEGRATIONS,
  isSecure = false,
  disabled = false,
}) {
  const dispatch = useDispatch()
  const customerIntegrations = useSelector(
    ({ integrations }) => integrations.integrations, // eslint-disable-line no-shadow
  )
  const selectedIntegration = useSelector(
    ({ integrations }) => integrations.selectedIntegration, // eslint-disable-line no-shadow
  )

  const selectedCustomerId = useSelector(getSelectedCustomerId)
  const allowedIntegrationKey = (
    Array.isArray(integrationsAllowed) ? integrationsAllowed : ALLOWED_DIRECTORY_INTEGRATIONS
  ).join(',')

  const onIntegrationSelect = useCallback(
    (integration) => {
      dispatch(integrations.actions.setSelectedIntegration(integration))
    },
    [dispatch],
  )

  // Choose the selected integration: this customer's M365 if present, otherwise its Google integration.
  useEffect(() => {
    if (!customerIntegrations?.length) {
      return
    }

    const allowedNames = allowedIntegrationKey.split(',')
    const allowedIntegrations = customerIntegrations.filter((integration) =>
      allowedNames.includes(integration?.IntegrationApplication?.application_name),
    )
    const preference = isSecure ? SECURE_DIRECTORY_PREFERENCE : DIRECTORY_INTEGRATION_PREFERENCE
    const nextIntegration = isSecure
      ? getPreferredDirectoryIntegration(allowedIntegrations, preference, { customerId: selectedCustomerId })
      : selectDirectoryIntegration({
          selectedIntegration,
          integrations: allowedIntegrations,
          customerId: selectedCustomerId,
          preference,
        })

    if (nextIntegration && nextIntegration.id !== selectedIntegration?.id) {
      dispatch(integrations.actions.setSelectedIntegration(nextIntegration))
    }
  }, [allowedIntegrationKey, customerIntegrations, dispatch, isSecure, selectedCustomerId, selectedIntegration])

  if (isChildLoading) {
    return <Button variant="light" className="spinner spinner--center spinner--md spinner--primary" />
  }

  return (
    <Dropdown drop="down" align="end" disabled={disabled}>
      {selectedIntegration && (
        <Dropdown.Toggle variant="light" className="font-color-2" disabled={disabled}>
          <Image
            src={selectedIntegration.IntegrationApplication?.icon_path}
            style={{
              width: 20,
              height: 20,
            }}
            className="me-3"
          />
          <span className="nav__link" style={{ minWidth: 125, textAlign: 'left' }}>
            <span className="nav__link nav__link-text font-color-2">
              {selectedIntegration.IntegrationApplication?.display_name}
            </span>
          </span>
        </Dropdown.Toggle>
      )}
      {!disabled && (
        <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-end dropdown-menu-anim dropdown-menu-top-unround">
          {customerIntegrations.map(
            (integration, index) =>
              integrationsAllowed.includes(integration.IntegrationApplication.application_name) && (
                <Dropdown.Item
                  key={index} // eslint-disable-line react/no-array-index-key
                  className="nav__item"
                  onClick={() => onIntegrationSelect(integration)}
                  style={{ minWidth: 200 }}
                >
                  <Image
                    src={integration.IntegrationApplication.icon_path}
                    style={{
                      width: 20,
                      height: 20,
                    }}
                    className="me-3"
                  />
                  <span className="nav__link">
                    <span className="nav__link nav__link-text">{integration.IntegrationApplication?.display_name}</span>
                  </span>
                </Dropdown.Item>
              ),
          )}
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
}

export default IntegrationsButton
